module.exports = __webpack_public_path__ + "img/DateTimeRange.7e243f19.svg";